//Bibliotecas
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
//Componentes material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core';
//Componentes
import Layout from './Layout';
import VitalizePaper from '../components/VitalizePaper';
import LabelSecao from '../components/LabelSecao';
import MaskedInput from 'react-text-mask';
import VitalizeFab from '../components/VitalizeFab';
//Controllers
import AdministradorController from '../controllers/AdministradorController';
import PermissaoController, { perfilAcesso } from '../controllers/PermissaoController';
//Utils
import { converterNumero } from '../utils/validacao';
//Models
import Administrador from '../models/Administrador';

const styles = () => ({
    secaoPermissoes: {
        width: '100%'
    },
    grupoPermissoes: {
        width: '100%',
        flexDirection: 'row'
    }
});

/**
 * Página com um formulário para edição e inclusão de administradores
 */
class AdministradorFormPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePermissoesChange = this.handlePermissoesChange.bind(this);
        //Controller
        this.administradorController = new AdministradorController();
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            valores: Administrador.clone({ nome: '', email: '', telefone: '', senha: '', permissoes: [ ], }),
            erros: {
                nome: '',
                email: '',
                telefone: '',
                senha: '',
                permissoes: ''
            },
            permissoes: [],
            sucesso: false,
            processando: false,
            carregando: true
        };
    }

    /**
     * Carrega os dados do administradores sendo editado e dos gêneros
     */
    async componentDidMount() {
        const id = this.getId();
        const state = Object.assign({}, this.state);
        state.carregando = false; //Indica que a consulta terminou
        //Consulta os gêneros
        state.permissoes = await this.obterPermissoes();
        
        if (id > 0)
        {
            //Carrega o administrador
            const result = await this.administradorController.obter(id);
            if (result.sucesso) {
                state.valores = result.administrador;
            }
        }

        this.setState(state);
    }

    /**
     * Carrega as permissões da API
     */
    async obterPermissoes() {
        const result = await this.permissaoController.listarPermissoes(perfilAcesso.ADMIN);
        if (result.sucesso) 
            return result.items;
        else
            return [];
    }

    /**
     * Recupera o Id do administrador a ser editado dos parâmetros da URL
     */
    getId() {
        let id;
        if (this.props.match)
            id = this.props.match.params.id;
        if (id === 'add')
            return 0;
        else
            return parseInt(id);
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const valores = Administrador.clone(this.state.valores);
        //Atualiza somente o valor do campo alterado
        valores[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState({ valores });
    }

    /**
     * Trata as alterações nas permissões selecionadas
     * @param {*} event Objeto contendo os dados do evento
     */
    handlePermissoesChange(event) {
        //Cria uma cópia dos dados do avalidor
        const valores = Administrador.clone(this.state.valores);
        //Converte o valor da permissão selecionada
        const id = converterNumero(event.target.value);
        //Caso o usuário tenha marcado uma opção
        if (event.target.checked)
            valores.permissoes.push(this.state.permissoes.find(item => item.id === id));
        else //Caso o usuário tenha desmarcado a opção
            valores.permissoes = valores.permissoes.filter(item => item.id !== id);
        //Atualiza o estado
        this.setState({ valores });
    }

    /**
     * Executa quando o form é submetido.
     * Envia os dados para a API
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleSubmit(event) {
        let result;
        //Impede a propagação do evento
        event.preventDefault();
        //Exibe loader
        this.setState({ processando: true });
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        state.processando = false; //Indica que o processamento terminou
        //Salva o registro
        const id = this.getId();
        
        if (id === 0)
            result = await this.administradorController.salvar(state.valores);
        else
            result = await this.administradorController.atualizar(state.valores);

        state.sucesso = result.sucesso;
        if (!result.sucesso) {
            state.erros = this.extrairMensagemErro(result);
        }
        this.setState(state);
    }

    /**
     * Retorna as mensagens de erro da API para exibição no formulário
     * @param {*} resultado Retorno do método salvar da API
     */
    extrairMensagemErro(resultado) {
        const erros = {
            nome: '',
            email: '',
            telefone: '',
            senha: '',
            permissoes: ''
        };

        for (let erro of resultado.erros) {
            if (erro.campo === 'nome')
                erros.nome = erro.mensagem;
            if (erro.campo === 'email')
                erros.email = erro.mensagem;
            if (erro.campo === 'telefone')
                erros.telefone = erro.mensagem;
            if (erro.campo === 'senha')
                erros.senha = erro.mensagem;
            if (erro.campo === 'permissoes')
                erros.permissoes = erro.mensagem;
        }

        return erros;
    }

    /**
     * Verifica se o usuário possui a permissão informada
     * @param {Permissao} permissao Permissão a ser verificada
     * @returns {Boolean} Retorna verdadeiro caso o usuário possua a permissão
     */
    verificarPermissaoSelecionada(permissao) {
        const permissoes = this.state.valores.permissoes;
        return !!permissoes.find(item => item.id === permissao.id);
    }

    render() {
        const { onLogout, classes, usuario, empresa, permissoes: modulosPermitidos } = this.props;
        const { sucesso, permissoes, processando, carregando } = this.state;
        const { 
            nome, 
            email,
            telefone, 
            senha
        } = this.state.valores;
        
        const { 
            nome: nomeErro, 
            email: emailErro, 
            telefone: telefoneErro, 
            senha: senhaErro,
            permissoes: permissoesErro
        } = this.state.erros;

        let senhaHelper = senhaErro;
        if (this.getId() > 0 && senhaHelper === '')
            senhaHelper = 'Deixe vazio para manter a senha';

        if (sucesso) return (<Redirect to="/administrador" />);

        return (
            <Layout onLogout={onLogout} returnLink="/administrador" usuario={usuario} empresa={empresa} permissoes={modulosPermitidos} carregando={carregando} >
                <CssBaseline />
                <form onSubmit={this.handleSubmit} noValidate >
                    <VitalizePaper>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <LabelSecao label="Administrador" />
                            </Grid>
                            <Grid item xs={12} >
                                <TextField 
                                    name="nome" 
                                    label="Nome" 
                                    type="text" 
                                    placeholder="Nome do administrador" 
                                    required
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!nomeErro}
                                    helperText={nomeErro}
                                    value={nome} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="email" 
                                    label="E-mail" 
                                    type="email" 
                                    placeholder="E-mail do administrador" 
                                    required={false}
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!emailErro}
                                    helperText={emailErro}
                                    value={email} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="telefone" 
                                    label="Telefone" 
                                    type="phone" 
                                    placeholder="Telefone do administrador" 
                                    required={false}
                                    variant="outlined" 
                                    fullWidth 
                                    InputProps={{ inputComponent: MaskedInput, inputProps: { mask:[ '(', /\d/, /\d/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ] } }}
                                    error={!!telefoneErro}
                                    helperText={telefoneErro}
                                    value={telefone} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="senha" 
                                    label="Senha" 
                                    type="password" 
                                    placeholder="Senha do administrador"
                                    required={this.getId() === 0}
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!senhaErro}
                                    helperText={senhaHelper}
                                    value={senha} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                        </Grid>
                    </VitalizePaper>
                    <FormControl component={VitalizePaper} error={!!permissoesErro} id="select-permissoes" className={classes.secaoPermissoes} >
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <FormLabel><LabelSecao label="Permissões" /></FormLabel>
                            </Grid>
                            <FormGroup className={classes.grupoPermissoes}>
                                {
                                    permissoes.map(permissao => (
                                        <Grid key={permissao.id} item xs={12} sm={6} md={3} >
                                            <FormControlLabel
                                                control={<Checkbox checked={this.verificarPermissaoSelecionada(permissao)} onChange={this.handlePermissoesChange} value={permissao.id} />}
                                                label={permissao.descricao}
                                            />
                                        </Grid>
                                    ))
                                }
                            </FormGroup>
                            <FormHelperText>{permissoesErro}</FormHelperText>
                        </Grid>
                    </FormControl>
                    <VitalizeFab color="primary" variant="extended" type="submit" loading={processando} >
                            Salvar
                    </VitalizeFab>
                </form>
            </Layout>
        );
    }
}

AdministradorFormPage.propTypes = {
    /** Evento disparado quando o usuário realiza o logout */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Parâmetros da URL */
    match: PropTypes.shape({
        params: PropTypes.shape({
            /** Id do administrador a ser editado */
            id: PropTypes.string
        })
    }),
    /** Classes CSS da página */
    classes: PropTypes.shape({
        secaoPermissoes: PropTypes.string,
        grupoPermissoes: PropTypes.string
    })
};

export default withStyles(styles)(AdministradorFormPage);